export default __webpack_public_path__ + "static/media/hero-img-10.7b451129.png";